import { createSlice } from '@reduxjs/toolkit';
import type { HomeSliceState } from '../interface';

const initialState: HomeSliceState = {
  productionData: [],
  optimalProductionData: [],
  equipements: [],
  loading: false,
  error: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setProductionData: (state, action) => {
      state.productionData = action.payload;
    },
    setOptimalProductionData: (state, action) => {
      state.optimalProductionData = action.payload;
    },
    setEquipements: (state, action) => {
      state.equipements = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setProductionData,
  setOptimalProductionData,
  setEquipements,
  setLoading,
  setError,
} = homeSlice.actions;

export default homeSlice;